"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5058],{

/***/ 35058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Flights_Flights; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
// EXTERNAL MODULE: ./src/context/BootstrapDataContext.tsx
var BootstrapDataContext = __webpack_require__(1377);
// EXTERNAL MODULE: ./src/hooks/useSeti.ts
var useSeti = __webpack_require__(22091);
;// CONCATENATED MODULE: ./src/components/Flights/Flights.tsx





var FlightsDesktop = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9126), __webpack_require__.e(6592), __webpack_require__.e(1555), __webpack_require__.e(7223), __webpack_require__.e(9379), __webpack_require__.e(766), __webpack_require__.e(3467), __webpack_require__.e(9029), __webpack_require__.e(4674), __webpack_require__.e(370), __webpack_require__.e(9914), __webpack_require__.e(1232), __webpack_require__.e(2365), __webpack_require__.e(49), __webpack_require__.e(2098)]).then(__webpack_require__.bind(__webpack_require__, 71098));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(71098)
            ];
        }
    }
});
var FlightsMobile = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9126), __webpack_require__.e(6592), __webpack_require__.e(1555), __webpack_require__.e(7223), __webpack_require__.e(3467), __webpack_require__.e(3885), __webpack_require__.e(4674), __webpack_require__.e(3872), __webpack_require__.e(1232), __webpack_require__.e(49), __webpack_require__.e(2632)]).then(__webpack_require__.bind(__webpack_require__, 30386));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(30386)
            ];
        }
    }
});
function Flights() {
    (0,useSeti/* default */.Z)('AA_FLIGHTS_LP') // AA Test: Unconditional firing and no visual changes
    ;
    var ref = (0,react.useContext)(BootstrapDataContext/* default */.Z), _isMobile = ref.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile;
    return isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FlightsMobile, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FlightsDesktop, {});
}
/* harmony default export */ var Flights_Flights = (Flights);

;// CONCATENATED MODULE: ./src/components/Flights/index.tsx



/***/ }),

/***/ 70710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useGA4AnalyticsForSETI; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@pcln/analytics/dist/esm/browser.js + 22 modules
var browser = __webpack_require__(45741);
// EXTERNAL MODULE: ./src/context/BootstrapDataContext.tsx
var BootstrapDataContext = __webpack_require__(1377);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/constants/page-map.ts
var pageMap = {
    '/': 'homepage',
    '/hotels': 'landingpage',
    '/flights': 'landingpage',
    '/vacationpackages': 'landingpage',
    '/vip': 'vip'
};
function mapPage(page) {
    return pageMap[page];
};

;// CONCATENATED MODULE: ./src/constants/product-map.ts
var productMap = {
    '/': '',
    '/hotels': 'hotel',
    '/flights': 'air',
    '/vacationpackages': 'bundle',
    '/vip': '',
    vacations: 'bundle',
    hotels: 'hotel',
    flights: 'air',
    cars: 'car',
    cruises: 'cruise'
};
function mapProduct(product) {
    return productMap[product];
};

;// CONCATENATED MODULE: ./src/hooks/useRouteInfo.ts



function useRouteInfo() {
    var ref = (0,router.useRouter)(), pathname = ref.pathname, query = ref.query;
    var pageName = mapPage(pathname);
    var currentTab = (query === null || query === void 0 ? void 0 : query.tab) && !Array.isArray(query.tab) ? query.tab : undefined;
    var productName = currentTab ? mapProduct(currentTab) : mapProduct(pathname);
    return {
        pageName: pageName,
        productName: productName
    };
};

;// CONCATENATED MODULE: ./src/hooks/useGA4Analytics.ts




function isSuccessfulSetiResponse(fullSeti) {
    return fullSeti.length === 0 || fullSeti[0].setiID !== undefined && fullSeti[0].setiVariantID !== undefined;
}
function useGA4AnalyticsForSETI(experimentCode) {
    var fullSETI = (0,react.useContext)(BootstrapDataContext/* default */.Z).fullSETI;
    var routeInfo = useRouteInfo();
    var logGA4Event = (0,react.useCallback)(function() {
        var baseSETI;
        if (isSuccessfulSetiResponse(fullSETI)) baseSETI = fullSETI.find(function(seti) {
            return seti.setiTagName === experimentCode;
        });
        if (!(baseSETI === null || baseSETI === void 0 ? void 0 : baseSETI.setiID)) return;
        browser/* default.GA4Enabled */.Z.GA4Enabled = true;
        browser/* default.logEvent */.Z.logEvent({
            event: 'seti',
            attributes: {
                seti_id: baseSETI.setiID,
                seti_variant_id: baseSETI.setiVariantID,
                seti_name: experimentCode,
                page_name: routeInfo.pageName,
                product_name: routeInfo.productName
            }
        });
        browser/* default.GA4Enabled */.Z.GA4Enabled = false;
    }, [
        experimentCode,
        fullSETI,
        routeInfo
    ]);
    return {
        logGA4Event: logGA4Event
    };
};


/***/ }),

/***/ 22091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useSeti; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _pcln_experimentation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80460);
/* harmony import */ var _context_ExperimentContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93107);
/* harmony import */ var _useGA4Analytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70710);




function useSeti(experimentCode) {
    var shouldFireImpression = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context_ExperimentContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z), tmp = ref[experimentCode], setiTest = tmp === void 0 ? 'DEFAULT' : tmp;
    var logGA4Event = (0,_useGA4Analytics__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(experimentCode).logGA4Event;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (experimentCode && shouldFireImpression) {
            _pcln_experimentation__WEBPACK_IMPORTED_MODULE_3__/* ["default"].fireImpression */ .Z.fireImpression(experimentCode);
            logGA4Event();
        }
    }, [
        experimentCode,
        logGA4Event,
        shouldFireImpression
    ]);
    return setiTest;
};


/***/ })

}]);